import { _ as _sfc_main } from "../../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import { resolveComponent, openBlock, createBlock, normalizeProps, guardReactiveProps, withCtx, createCommentVNode, mergeProps } from "vue";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-3194dc60.mjs";
import "../../_VListItem-508e4b13.mjs";
import "../../_density-8094aebe.mjs";
import "../../MalarkeyContactAvatar-1b079ba3.mjs";
import "../../_proxiedModel-031e293c.mjs";
import "../../_common-fcf3ef61.mjs";
import "../../helpers-674591c1.mjs";
import "joi";
import "../../_commonjsHelpers-ca272635.mjs";
import "../../i18n-35335a5c.mjs";
import "../../index-38c53cf2.mjs";
import "../../_i18n-e414d464.mjs";
import "../../index-64135f7d.mjs";
import "../../index-703c58ee.mjs";
import "../../malarkeyTwilioAdapter-1c296255.mjs";
import "../../index-13be80af.mjs";
import "../../_debug-8b5c3032.mjs";
import "../../event-socket/malarkeyEventSocketAdapter.es.js";
import "../../otpauth.esm-675c01d0.mjs";
import "../../sudo-bad5b55e.mjs";
import "../../index-fd2245c5.mjs";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VCheckboxBtn = resolveComponent("VCheckboxBtn");
  const _component_v_avatar = resolveComponent("v-avatar");
  const _component_MalarkeyContactAvatar = resolveComponent("MalarkeyContactAvatar");
  const _component_v_list_item = resolveComponent("v-list-item");
  return openBlock(), createBlock(_component_v_list_item, normalizeProps(guardReactiveProps(_ctx.bindings)), {
    prepend: withCtx(() => [
      _ctx.selectable ? (openBlock(), createBlock(_component_VCheckboxBtn, {
        key: 0,
        modelValue: _ctx.active,
        ripple: false,
        tabindex: "-1",
        onClick: _ctx.doPreventDefault
      }, null, 8, ["modelValue", "onClick"])) : createCommentVNode("", true),
      !_ctx.useContactAvatar ? (openBlock(), createBlock(_component_v_avatar, {
        key: 1,
        size: 14,
        color: _ctx.dotColor
      }, null, 8, ["color"])) : (openBlock(), createBlock(_component_MalarkeyContactAvatar, normalizeProps(mergeProps({ key: 2 }, _ctx.contactAvatarBindings)), null, 16))
    ]),
    _: 1
  }, 16);
}
const MalarkeyContactSearchItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyContactSearchItem.vue"]]);
export {
  MalarkeyContactSearchItem as default
};
//# sourceMappingURL=MalarkeyContactSearchItem.es.js.map
